const TYPE_COLOR = {
    REQUEST: "var(--ink-muted)",
    RESPONSE: "var(--forest)",
    ACCEPTANCE: "var(--forest)",
    EXCEPTION: "var(--crimson)",
    HANDOVER: "var(--ink)",
    OUTCOME: "var(--forest)",
};

export const ReceiptList = ({ receipts }) => (
    <section
        className="bg-white"
        style={{ border: "4px double var(--ink)" }}
        data-testid="journey-receipts"
    >
        <div className="border-b hairline px-6 py-5 sm:px-8">
            <p className="mono-label">Journey receipts</p>
            <h2 className="font-serif mt-1" style={{ fontSize: 26 }}>
                Every material handover and decision, receipted
            </h2>
            <p className="mt-1 text-sm" style={{ color: "var(--ink-soft)" }}>
                Requests, responses, exceptions, acceptances, handovers and outcomes.
                Receipts are simulated locally unless a KATLAS credential is configured —
                node activity is never fabricated.
            </p>
        </div>
        <ol className="divide-y" style={{ borderColor: "var(--rule)" }}>
            {receipts.length === 0 && (
                <li className="px-6 py-6 text-sm sm:px-8" style={{ color: "var(--ink-muted)" }}>
                    No receipts yet.
                </li>
            )}
            {receipts.map((r) => (
                <li key={r.receipt_id} className="px-6 py-4 sm:px-8" data-testid={`receipt-${r.seq}`}>
                    <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
                        <span className="mono-data" style={{ fontSize: 11 }}>
                            {String(r.seq).padStart(2, "0")}
                        </span>
                        <span
                            className="mono-label border px-1.5 py-0.5"
                            style={{ color: TYPE_COLOR[r.type], borderColor: TYPE_COLOR[r.type], fontSize: 9.5 }}
                        >
                            {r.type}
                        </span>
                        <span className="mono-label" style={{ fontSize: 10 }}>{r.boundary}</span>
                        <span
                            className="mono-label ml-auto border px-1.5 py-0.5"
                            style={{
                                fontSize: 9.5,
                                color: r.signature?.mode === "KATLAS_SIGNED" ? "var(--forest)" : "var(--amber)",
                                borderColor: r.signature?.mode === "KATLAS_SIGNED" ? "var(--forest)" : "var(--amber)",
                            }}
                        >
                            {r.signature?.mode === "KATLAS_SIGNED" ? "KATLAS SIGNED" : "SIMULATED"}
                        </span>
                    </div>
                    <p className="mt-1.5 text-sm leading-relaxed" style={{ color: "var(--ink)" }}>
                        {r.summary}
                    </p>
                    <p className="mono-data mt-1" style={{ fontSize: 10.5, color: "var(--ink-muted)" }}>
                        {r.receipt_id} · {r.actor} → {r.counterparty} · {r.content_digest?.slice(0, 26)}… · {new Date(r.ts).toLocaleTimeString()}
                    </p>
                </li>
            ))}
        </ol>
    </section>
);
